import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { MaterialConfiguration } from 'app/core/components/workflow-new/material/configurations/material-configuration';

@Component({
  selector: 'itpx-deliverable-tile-loading',
  templateUrl: './deliverable-tile-loading.component.html',
  styleUrls: ['./deliverable-tile-loading.component.css', '../../common/style.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeliverableTileLoadingComponent implements OnInit {
  @Input() conf: MaterialConfiguration;
  private imageWidth: string;
  private imageHeight: string;
  constructor() { }

  ngOnInit() {
    Object.assign(this, this.conf);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/deliverable-tile-loading/deliverable-tile-loading.component.ts